"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6.317 4.742a1.832 1.832 0 00-2.712-.259c-.706.653-.762 1.756-.19 2.532l3.687 4.962-3.71 5.008c-.572.777-.527 1.88.19 2.532a1.832 1.832 0 002.713-.259l5.178-6.988a.491.491 0 000-.574L6.317 4.742zm11.366 0a1.832 1.832 0 012.712-.259c.706.653.762 1.756.19 2.532l-3.687 4.962 3.71 5.008c.571.777.526 1.88-.19 2.532a1.832 1.832 0 01-2.713-.259l-5.167-7a.492.492 0 010-.573l5.145-6.943z" }), "Mixer");
//# sourceMappingURL=Mixer.js.map